<template>
  <div
    class="bg-primary text-white rounded-3xl p-8 shadow-2xl shadow-primary/30 relative overflow-hidden group"
  >
    <div
      class="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl group-hover:bg-white/20 transition-all duration-700"
    ></div>
    <h3
      class="text-xl font-black mb-4 relative z-10 uppercase tracking-tighter italic"
    >
      {{ $t("drive_business") }}
    </h3>
    <p
      class="text-xs text-white/70 leading-relaxed mb-6 relative z-10 font-bold uppercase tracking-widest"
    >
      {{ $t("drive_business_desc") }}
    </p>
    <BaseButton
      type="white"
      class="w-full !rounded-2xl !py-4 font-black uppercase tracking-widest text-sm relative z-10 shadow-xl"
      @click="$router.push('/cars/create')"
    >
      {{ $t("add_car") }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/Button.vue";

export default {
  name: "DashboardPromoBanner",
  components: { BaseButton },
};
</script>
